export default function ExtraTallRowIcon() {
  return (
    <svg
      width='14'
      height='15'
      viewBox='0 0 14 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='shrink-0 size-3.5'
    >
      <mask
        id='mask0_extra_tall_row'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='14'
        height='15'
      >
        <rect width='14' height='15' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_extra_tall_row)'>
        <path
          d='M12.5417 11.2689C12.5417 10.9467 12.2805 10.6855 11.9583 10.6855H2.04167C1.7195 10.6855 1.45834 10.9467 1.45834 11.2689V11.2689C1.45834 11.591 1.7195 11.8522 2.04167 11.8522H11.9583C12.2805 11.8522 12.5417 11.591 12.5417 11.2689V11.2689Z'
          fill='currentColor'
        />
        <mask id='mask1_extra_tall_row' fill='white'>
          <rect x='1.45834' y='2.51953' width='11.0833' height='6.50895' rx='1.16667' />
        </mask>
        <rect
          x='1.45834'
          y='2.51953'
          width='11.0833'
          height='6.50895'
          rx='1.16667'
          stroke='currentColor'
          strokeWidth='2.91667'
          mask='url(#mask1_extra_tall_row)'
        />
      </g>
    </svg>
  );
}
